import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-white to-secondary/5 pt-24 pb-16 lg:pt-32 lg:pb-24">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%2307B0E9%22%20fill-opacity%3D%220.03%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E')] opacity-40"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full">
                <Icon name="Users" size={16} className="text-primary mr-2" />
                <span className="text-sm font-medium text-primary">Join 500+ Certified Contractors</span>
              </div>
              
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-jakarta font-bold text-text-primary leading-tight">
                Partner with OpenbooQ
                <span className="block text-primary">Grow Your Business</span>
              </h1>
              
              <p className="text-lg lg:text-xl text-text-secondary leading-relaxed max-w-2xl">
                Join the future of roofing. Get steady work, fair pricing, and professional growth opportunities with our transparent marketplace platform.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="default" 
                size="lg"
                iconName="FileText"
                iconPosition="left"
              >
                Apply Now
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="Play"
                iconPosition="left"
              >
                Watch How It Works
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-jakarta font-bold text-primary">$150K+</div>
                <div className="text-sm text-text-secondary">Avg Annual Revenue</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-jakarta font-bold text-primary">98%</div>
                <div className="text-sm text-text-secondary">Customer Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-jakarta font-bold text-primary">24/7</div>
                <div className="text-sm text-text-secondary">Support Available</div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-trust p-8 lg:p-12">
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
                    <Icon name="Award" size={24} className="text-white" />
                  </div>
                  <div>
                    <p className="font-jakarta font-semibold text-text-primary">Certified Partner</p>
                    <p className="text-sm text-text-secondary">Premium contractor status</p>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <span className="text-sm font-medium text-text-primary">Monthly Jobs</span>
                    <span className="text-lg font-jakarta font-bold text-primary">15-25</span>
                  </div>
                  <div className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <span className="text-sm font-medium text-text-primary">Avg Job Value</span>
                    <span className="text-lg font-jakarta font-bold text-primary">$12,500</span>
                  </div>
                  <div className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <span className="text-sm font-medium text-text-primary">Commission Rate</span>
                    <span className="text-lg font-jakarta font-bold text-success">10%</span>
                  </div>
                </div>
                
                <div className="pt-4 border-t border-border">
                  <div className="flex items-center space-x-2">
                    <Icon name="TrendingUp" size={16} className="text-success" />
                    <span className="text-sm font-medium text-success">+23% growth this quarter</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-gradient-to-br from-conversion-accent to-primary rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-gradient-to-br from-secondary to-accent rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;